import { createRouter } from "@tanstack/react-router";

import { routeTree } from "routeTree.gen";
import { Pillar } from "types/pillar/Pillar";
import { MessageDescriptor } from "react-intl";
import { DefaultErrorFallback } from "lib/error/DefaultErrorFallback";

// Set up a Router instance
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  search: { strict: false },
  defaultErrorComponent: ({ error }) => {
    return <DefaultErrorFallback error={error} />;
  },
});

// Register routes for type safety across the entire project
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }

  // History state type definition
  // Note: We should prefer search/query params over history state when possible
  interface HistoryState {
    pillar?: Pillar;
    legacyFolderId?: string;
    referrer?: string;
  }

  interface StaticDataRouteOption {
    /**
     * Used for page/window titles and breadcrumbs segments.
     */
    pageTitle?: string | MessageDescriptor;
    /**
     * If true, it means the breadcrumbs segment for the route should use pageTitle as text, not a
     * link. Used mainly on some layout routes with breadcrumbs segments added only to reflect
     * hierarchy.
     */
    textOnlyBreadcrumbsSegment?: boolean;
  }
}
